'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _formParse = require('form-parse');

var _formParse2 = _interopRequireDefault(_formParse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Form = function (_Component) {
  _inherits(Form, _Component);

  function Form() {
    _classCallCheck(this, Form);

    return _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).apply(this, arguments));
  }

  _createClass(Form, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var className = (0, _classnames3.default)(_defineProperty({
        Form: true
      }, this.props.className, !!this.props.className));

      return _react2.default.createElement(
        'form',
        {
          autoComplete: this.props.autocomplete,
          className: className,
          noValidate: true,
          onSubmit: this.handleSubmit.bind(this),
          ref: function ref(el) {
            return _this2.form = el;
          } },
        this.props.children
      );
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      e.preventDefault();
      var form = this.form;

      if (form.checkValidity()) {
        var data = (0, _formParse2.default)(form, this.props.transform);
        if (this.props.onSubmit) {
          this.props.onSubmit(data, form);
        }
      }
    }
  }]);

  return Form;
}(_react.Component);

exports.default = Form;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-forms/lib/Form.js
// module id = 1107
// module chunks = 0